import React from 'react';

function WheelCenter() {
  return (
    <div className="wheel-center">
      <svg x="0px" y="0px" viewBox="0 0 530.9 612.8">
        <polygon
          points="284.7,306.4 530.9,153.2 275.1,289.8 265.6,0 256,289.4 0,153.6 246.8,306.2 0.2,459.6 256,323 265.6,612.8 275.1,323 530.9,459.6"
        />
      </svg>
    </div>
  );
}

export default WheelCenter;



// WEBPACK FOOTER //
// js/src/wheel/WheelCenter.js